import { render, staticRenderFns } from "./RoundFavoriteIconButton.vue?vue&type=template&id=1a942967&scoped=true&"
import script from "./RoundFavoriteIconButton.vue?vue&type=script&lang=ts&"
export * from "./RoundFavoriteIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./RoundFavoriteIconButton.vue?vue&type=style&index=0&id=1a942967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a942967",
  null
  
)

export default component.exports